import { render } from "./LeagueTable.vue?vue&type=template&id=255bee93&scoped=true&ts=true"
import script from "./LeagueTable.vue?vue&type=script&lang=ts"
export * from "./LeagueTable.vue?vue&type=script&lang=ts"

import "./LeagueTable.vue?vue&type=style&index=0&id=255bee93&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255bee93"]])

export default __exports__